
import { Component, Input, OnChanges, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';
import { PaginatorModule } from 'primeng/paginator';
import { ActionHistory } from 'src/app/core-module/models/Audits/action-history';
import { UtilService } from 'src/app/core-module/services/util.service';

@Component({
  selector: 'app-action-history-timeline',
  standalone: true,
  imports: [PaginatorModule],
  templateUrl: './action-history-timeline.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './action-history-timeline.component.scss'
})
export class ActionHistoryTimelineComponent implements OnChanges {
  @Input() history: ActionHistory[] = [];

  pageSize: number = 5;
  pageIndex: number = 0;

  constructor(public util: UtilService){}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['history']) {
      this.pageIndex = 0;
    }
  }

  get pagedHistory(): ActionHistory[] {
    const start = this.pageIndex * this.pageSize;
    return this.history.slice(start, start + this.pageSize);
  }

  totalPages(): number {
    return Math.ceil((this.history?.length || 0) / this.pageSize);
  }

  canPrev(): boolean {
    return this.pageIndex > 0;
  }

  canNext(): boolean {
    return this.pageIndex < this.totalPages() - 1;
  }

  onPageChange(event: any){
    this.pageIndex = event.page ?? 0;
    this.pageSize = event.rows ?? this.pageSize;
  }
}
